import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const projectNodeDataArraySelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model?.nodeDataArray || []
  );

export const prevProjectNodeDataArraySelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model?.modelData.draftData?.prevNodeDataArray || []
  );
